import React, { useEffect, useState } from "react";
import { FiFilter } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../utils/redux/hooks";
import { RootState } from "../../../utils/redux/store";
import { addcustomerOrders, addisLoading } from "../../../utils/redux/mainSlice";
import AllOrders from "./TempTwoTabs/allOrders";
import GoBack from "../../GoBack";
import axios from 'axios';

const items = [
  "All Orders",
  "Pending",
  "Accepted",
  "In Progress",
  "In Dispute",
  "Track",
  "Completed",
  "Declined",
  "Cancelled",
];

const TempSeven = () => {
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [currentProvider, setCurrentProvider] = useState<any>(null);
  const [selectedTab, setSelectedTab] = useState(items[0]);

  const viewWallet: any = useAppSelector(
    (store: RootState) => store.user.viewWallet
  );

  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchProviderDetails = async () => {
      dispatch(addisLoading(true));
      const AuthToken = await localStorage.getItem("AuthToken");
      try {
        const response = await axios.get(
          `https://api.pureworker.com/api/admin/providers?_id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${AuthToken}`,
            },
          }
        );

        if (response.status === 200 || response.status === 201) {
          const providerDetails = response.data?.providers?.results[0]; 
          setCurrentProvider(providerDetails);
          dispatch(addcustomerOrders(providerDetails.orders || [])); 
        } else {
          console.error("Failed to fetch provider details:", response.status);
        }
      } catch (error) {
        console.error("Error fetching provider details:", error);
      } finally {
        dispatch(addisLoading(false));
      }
    };

    fetchProviderDetails();
  }, [id, dispatch]);

 
  const customerOrders = currentProvider?.orders || [];
  const pending = customerOrders.filter((item: any) => item?.status === "PENDING");
  const accepted = customerOrders.filter((item: any) => item?.status === "ACCEPTED");
  const inprogress = customerOrders.filter((item: any) => item?.status === "INPROGRESS");
  const completed = customerOrders.filter((item: any) => item?.status === "COMPLETED");
  const declined = customerOrders.filter((item: any) => item?.status === "DECLINED");
  const canceled = customerOrders.filter((item: any) => item?.status === "CANCELLED");
  const dispute = customerOrders.filter((item: any) => item?.status === "DISPUTE");
  const track = customerOrders.filter((item: any) => item?.status === "TRACK");

  const toggleFilter = () => {
    setIsFilterClicked((prev) => !prev);
  };

  const userName =
    currentProvider?.businessName ||
    `${currentProvider?.firstName || "Unknown"} ${currentProvider?.lastName || ""}`;

  return (
    <div className="lg:px-3 px-0 space-y-4">
      <div className="flex justify-between mb-6">
        <div className="hidden w-full lg:flex flex-col lg:flex-row justify-between gap-4 items-center">
          <div className="relative flex gap-4 text-[#88087B] items-center">
            <GoBack />
            <p className="font-roboto text-2xl lg:text-3xl font-medium leading-normal">
              {userName}
            </p>
            <p className="border-l-2 border-[#000] px-2 font-roboto text-base sm:text-lg font-medium leading-normal">
              Rating: {(currentProvider?.recommendRating || 0).toFixed(2)}
            </p>
            <p className="border border-[#000] px-1 font-roboto text-base sm:text-lg font-medium leading-normal">
              Wallet Balance: ₦{" "}
              {currentProvider?.wallet?.availableBalance.toLocaleString()}
            </p>
          </div>

          <div className="relative" id="filter-container">
            <FiFilter
              size={20}
              className="text-[#88087B] cursor-pointer"
              onClick={toggleFilter}
            />
            {isFilterClicked && (
              <div className="absolute top-5 right-0 space-y-2 border w-max p-6 bg-white rounded-sm">
                {items.map((item, index) => (
                  <p
                    key={index}
                    className={`flex py-1 justify-between gap-3 hover:border-b-2 hover:border-[#88087B] font-roboto lg:text-base text-sm font-medium leading-normal cursor-pointer whitespace-nowrap ${
                      item === selectedTab
                        ? "border-b-2 border-[#88087B]"
                        : ""
                    }`}
                    onClick={() => {
                      setSelectedTab(item);
                      toggleFilter();
                    }}
                  >
                    <span>{item}</span>
                    <span className="bg-[#88087B] text-[#fff] text-sm px-1 rounded-sm">
                      {item === "All Orders"
                        ? customerOrders.length
                        : item === "Pending"
                        ? pending.length
                        : item === "Accepted"
                        ? accepted.length
                        : item === "In Progress"
                        ? inprogress.length
                        : item === "In Dispute"
                        ? dispute.length
                        : item === "Completed"
                        ? completed.length
                        : item === "Declined"
                        ? declined.length
                        : item === "Cancelled"
                        ? canceled.length
                        : item === "Track"
                        ? track.length
                        : 0}
                    </span>
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex lg:hidden flex-col text-[#88087B] w-full justify-between gap-4 items-center">
          <div className="flex justify-between w-full items-center">
            <p className="font-roboto text-3xl lg:text-3xl font-medium leading-normal">
              {userName}
            </p>
            <p className="border-x-2 px-4 border-[#000] font-roboto text-base sm:text-lg font-medium leading-normal">
              Rating: {(currentProvider?.recommendRating || 0).toFixed(2)}
            </p>

            <div className="relative" id="filter-container">
              <FiFilter
                size={20}
                className="text-[#88087B] cursor-pointer"
                onClick={toggleFilter}
              />
              {isFilterClicked && (
                <div className="absolute top-5 right-0 space-y-2 border w-max p-6 bg-white rounded-sm">
                  {items.map((item, index) => (
                    <p
                      key={index}
                      className={`flex py-1 justify-between gap-3 hover:border-b-2 hover:border-[#88087B] font-roboto lg:text-base text-sm font-medium leading-normal cursor-pointer whitespace-nowrap ${
                        item === selectedTab
                          ? "border-b-2 border-[#88087B]"
                          : ""
                      }`}
                      onClick={() => {
                        setSelectedTab(item);
                        toggleFilter();
                      }}
                    >
                      <span>{item}</span>
                      <span className="bg-[#88087B] text-[#fff] text-sm px-1 rounded-sm">
                        {item === "All Orders"
                          ? customerOrders.length
                          : item === "Pending"
                          ? pending.length
                          : item === "Accepted"
                          ? accepted.length
                          : item === "In Progress"
                          ? inprogress.length
                          : item === "In Dispute"
                          ? dispute.length
                          : item === "Completed"
                          ? completed.length
                          : item === "Declined"
                          ? declined.length
                          : item === "Cancelled"
                          ? canceled.length
                          : item === "Track"
                          ? track.length
                          : 0}
                      </span>
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>

          <p
            onClick={() => {
              navigate(`/provider5`);
            }}
            className="border border-[#000] px-2 font-roboto text-base sm:text-xl font-medium leading-normal"
          >
            Wallet Balance: ₦{" "}
            {viewWallet?.wallet?.availableBalance.toLocaleString()}
          </p>
        </div>
      </div>

      <div className="w-full">
        <AllOrders selectedTab={selectedTab} />
      </div>
    </div>
  );
};

export default TempSeven;
